import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const CHECK_SERVICE_START = 'CHECKOUT_INFO :: CHECK_SERVICE_START';

export type TCheckServiceStartAction = IReduxAction<typeof CHECK_SERVICE_START>;

export const checkServiceStart = actionGenerator<typeof CHECK_SERVICE_START>(CHECK_SERVICE_START);
